module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page-fixed-height': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "sideways-page-one",
    class: {
      'disabled': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbs
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Roles")]), _vm._v(" "), _c('div', {
    staticClass: "note note-info"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.note) + "\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.throttledCreate()
      }
    }
  }, [_vm._v("Create a New Role")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title",
    on: {
      "click": function($event) {
        _vm.toggleSearchPanel()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.searchCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.advancedRoleSearch()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.searchError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearSearchError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advancedSearch.search),
      expression: "advancedSearch.search"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.advancedSearch.search.length
    },
    attrs: {
      "type": "text",
      "id": "search_options_search",
      "tabindex": _vm.activePanel ? 0 : -1
    },
    domProps: {
      "value": (_vm.advancedSearch.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), (_vm.computedSearchOptions.length) ? _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("Search by "), _vm._l((_vm.computedSearchOptions), function(option, index) {
    return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(option.name))])
  }), _vm._v(".")], 2) : _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("Select search terms below.")])]), _vm._v(" "), _c('div', {
    staticClass: "md-checkbox-inline margin-top-25"
  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
    return _c('div', {
      staticClass: "md-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.checked),
        expression: "option.checked"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": ("advanced_search_checkbox_" + (option.value))
      },
      domProps: {
        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
      },
      on: {
        "change": function($event) {
          var $$a = option.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (option.checked = $$a.concat([$$v]))
            } else {
              $$i > -1 && (option.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(option, "checked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("advanced_search_checkbox_" + (option.value))
      }
    }, [_c('span'), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advancedSearch.approval_permission),
      expression: "advancedSearch.approval_permission"
    }],
    staticClass: "form-control edited",
    attrs: {
      "id": "search_options_approval_permission",
      "tabindex": _vm.activePanel ? 0 : -1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.advancedSearch, "approval_permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Approval Permission")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("No Approval Permission")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_status"
    }
  }, [_vm._v("Approval Permission")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('typeahead', {
    attrs: {
      "data": _vm.apps,
      "label": 'App',
      "emitter": 'app',
      "passedValue": _vm.advancedSearch.app,
      "objectKey": 'app_name',
      "tabindex": _vm.activePanel ? 0 : -1
    },
    on: {
      "app": _vm.updateApp,
      "onFocus": _vm.appFocus
    }
  }), _vm._v(" "), (_vm.advancedSearch.app.app_id) ? _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("Choose a level of app access below:")]) : _vm._e()], 1), _vm._v(" "), (_vm.advancedSearch.app.app_id) ? _c('div', {
    staticClass: "md-radio-inline margin-top-25"
  }, [_c('div', {
    staticClass: "md-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advancedSearch.access_level),
      expression: "advancedSearch.access_level"
    }],
    staticClass: "md-radio",
    attrs: {
      "type": "radio",
      "id": "advanced_search_radio_none",
      "name": "advanced_search_access_level",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.advancedSearch.access_level, "none")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.advancedSearch, "access_level", "none")
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "md-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advancedSearch.access_level),
      expression: "advancedSearch.access_level"
    }],
    staticClass: "md-radio",
    attrs: {
      "type": "radio",
      "id": "advanced_search_radio_view",
      "name": "advanced_search_access_level",
      "value": "view"
    },
    domProps: {
      "checked": _vm._q(_vm.advancedSearch.access_level, "view")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.advancedSearch, "access_level", "view")
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "md-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advancedSearch.access_level),
      expression: "advancedSearch.access_level"
    }],
    staticClass: "md-radio",
    attrs: {
      "type": "radio",
      "id": "advanced_search_radio_view_modify",
      "name": "advanced_search_access_level",
      "value": "modify"
    },
    domProps: {
      "checked": _vm._q(_vm.advancedSearch.access_level, "modify")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.advancedSearch, "access_level", "modify")
      }
    }
  }), _vm._v(" "), _vm._m(3)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "tabindex": _vm.activePanel ? 0 : -1
    },
    on: {
      "click": function($event) {
        _vm.resetRoleSearch()
      }
    }
  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "tabindex": _vm.activePanel ? 0 : -1
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "relative-block"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.loadingRoleData,
      "color": '#3598dc',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.loadingRoleData === false) ? _c('div', [_c('div', {
    staticClass: "clearfix"
  }, [_c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', {
    staticClass: "rounded-button-group-block"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn blue btn-outline",
    class: {
      'active': _vm.sortBy.order === 'asc'
    },
    attrs: {
      "for": "sort_asc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy.order),
      expression: "sortBy.order"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "id": "sort_asc",
      "value": "asc"
    },
    domProps: {
      "checked": _vm._q(_vm.sortBy.order, "asc")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.sortBy, "order", "asc")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('label', {
    staticClass: "btn blue btn-outline",
    class: {
      'active': _vm.sortBy.order === 'desc'
    },
    attrs: {
      "for": "sort_desc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy.order),
      expression: "sortBy.order"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "id": "sort_desc",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.sortBy.order, "desc")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.sortBy, "order", "desc")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.sortBy.field === 'role_name'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSortField('role_name')
      }
    }
  }, [_vm._v("Role Name")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.sortBy.field === 'num_accounts'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSortField('num_accounts')
      }
    }
  }, [_vm._v("# of Accounts")])])])]), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
    staticClass: "margin-top-30 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.roles), function(role) {
    return _c('tr', [_c('td', [_c('h3', [_vm._v(_vm._s(role.role_name) + " "), (role.locked_role) ? _c('small', [_c('i', {
      staticClass: "fa fa-lock font-grey-cascade"
    })]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(role.num_accounts || 0))]), _vm._v(" " + _vm._s(role.num_accounts === 1 ? 'account' : 'accounts'))])]), _vm._v(" "), _c('td', [(role.approval_permission) ? _c('i', {
      staticClass: "fa fa-check font-green-haze"
    }) : _c('i', {
      staticClass: "fa fa-close font-red-thunderbird"
    })]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
      attrs: {
        "slot": "button",
        "type": "button",
        "data-toggle": "dropdown"
      },
      slot: "button"
    }, [_c('i', {
      staticClass: "fa fa-cogs"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "slot": "dropdown-menu"
      },
      slot: "dropdown-menu"
    }, [(!role.locked_role) ? _c('li', [(role.approval_permission) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.modifyApprovalPermissions(role, 'remove')
        }
      }
    }, [_vm._v("Remove Approval Permission")]) : _c('a', {
      on: {
        "click": function($event) {
          _vm.modifyApprovalPermissions(role, 'add')
        }
      }
    }, [_vm._v("Assign Approval Permission")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editRolePermissions(role.role_id)
        }
      }
    }, [_vm._v("View App Access")])]), _vm._v(" "), (!role.locked_role) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editRoleName(role.role_id)
        }
      }
    }, [_vm._v("Edit Role Name")])]) : _vm._e(), _vm._v(" "), (!role.locked_role) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.deleteRoleConfirmation('delete', role)
        }
      }
    }, [_vm._v("Delete Role")])]) : _vm._e()])])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
    attrs: {
      "show": _vm.numPages === 0,
      "type": 'roles'
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sideways-page-two",
    class: {
      'active': !_vm.activePanel, 'inactive': _vm.activePanel
    },
    style: ({
      height: _vm.computedHeight
    })
  }, [_c('div', {
    staticClass: "sideways-blank-fold"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn blue btn-lg margin-bottom-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-role', {
    attrs: {
      "baseRoute": _vm.baseRoute,
      "baseRouteName": _vm.baseRouteName,
      "businessId": _vm.businessId
    }
  }), _vm._v(" "), _c('edit-role-name', {
    attrs: {
      "baseRoute": _vm.baseRoute,
      "baseRouteName": _vm.baseRouteName
    }
  }), _vm._v(" "), _c('edit-role-permissions', {
    attrs: {
      "baseRoute": _vm.baseRoute,
      "baseRouteName": _vm.baseRouteName,
      "businessId": _vm.businessId
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n\t\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "advanced_search_radio_none"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNo Access\n\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "advanced_search_radio_view"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tView Access\n\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "advanced_search_radio_view_modify"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tView & Modify Access\n\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-blue"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Approval Permission")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Actions")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b94386cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Roles/Roles.vue
// module id = 455
// module chunks = 1